import React from 'react';
import styles from './chip.module.css';
export type ChipColor = 'danger' | 'warning';

export type ChipProps = {
  color: ChipColor;
  children: React.ReactNode;
  pointer: boolean | undefined;
};

export default function Chip({ color, children, pointer }: ChipProps) {
  return (
    <button
      className={`${styles[`app-chip`]}
        ${styles[`bg-${color}-100`]}
        ${styles[`text-${color}-200`]} ${pointer ? styles.pointer : ``}`}
      type="button"
    >
      {children}
    </button>
  );
}
